import React from "react";
import { FormProvider } from "../../../context/form/form.provider";
import { FormInitInputs } from "../../../@types/form.types";
import { GeneratePlaylistByType } from "./contentForm";
import { GenerateFormType } from "../../../@types/playlist.types";
import { PLAYLIST_SORT_TYPES } from "../../../constants/constants";

type PlaylistGenerateModalProps = {
  type: GenerateFormType;
  isOpen?: boolean;
  onClose: () => void;
  asAdmin?: boolean;
};
export default function PlaylistGenerateModal({
  type,
  isOpen,
  onClose,
  asAdmin,
}: PlaylistGenerateModalProps) {
  const formInitialState: FormInitInputs = {
    title: {
      name: "title",
      label: "Playlist Title",
      type: "text",
      required: true,
      rules: { length: { min: 5 } },
      value: "",
      popoverText: "Title of the playlist",
      hinterText: "*required",
    },
    sort: {
      name: "sort",
      label: "Video Sort",
      type: "select",
      required: true,
      value: "",
      options: PLAYLIST_SORT_TYPES,
      popoverText: "Please select a sort type",
    },
    tags: {
      name: "tags",
      label: "Tags",
      type: "chip",
      value: [],
      popoverText: "Commas or semicolon will separate the tags",
    },
    excludedTags: {
      name: "excludedTags",
      label: "Excluded Tags",
      type: "chip",
      value: [],
      popoverText: "Commas or semicolon will separate the tags",
    },
    categories: {
      name: "categories",
      label: "Categories",
      type: "chip",
      value: [],
      popoverText: "Commas or semicolon will separate the Categories",
    },
  };

  return (
    <FormProvider formInputFields={formInitialState}>
      <GeneratePlaylistByType
        isOpen={isOpen}
        onClose={onClose}
        type={type}
        asAdmin={asAdmin}
      />
    </FormProvider>
  );
}
